<template>
    <p class="lender-info-text">
        <span class="lender-info-value">{{ columnValue }}</span>
        <span class="lender-info-label t-small">{{ valueLabel }}</span>
    </p>
</template>

<script>
export default {
    props: ['columnValue', 'valueLabel'],
}
</script>
